import { render, staticRenderFns } from "./BulkNotificationModal.vue?vue&type=template&id=38d99244&scoped=true&"
import script from "./BulkNotificationModal.vue?vue&type=script&lang=js&"
export * from "./BulkNotificationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d99244",
  null
  
)

export default component.exports